import { Box, Text } from '@chakra-ui/react';

const GeneralInfo = () => {
  return (
    <Box>
      <Box mb={12}>
        <Text fontSize="md" fontWeight={600}>
          Overview
        </Text>
        <Text fontSize="xs">
          Timeero connects directly with ADP Workforce Now. Expedite payroll by exporting timesheets right into ADP. ADP
          Connector charges may apply.
        </Text>
      </Box>
      <Box>
        <Text fontSize="md" fontWeight={600}>
          What does this integration do?
        </Text>
        <Text fontSize="xs">
          With Timeero you can export time worked and mileage reimbursement amounts right into ADP WorkforceNow
        </Text>
      </Box>
    </Box>
  );
};
export default GeneralInfo;
